import React, { useRef } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import Modal from "../../common/components/ThemedModal";
import { FaUsers } from "react-icons/fa";
import { League, LeagueWithSportsAndSeries } from "../../../types/model";

interface InviteFriendsModalProps {
	inviteFriendsModal: boolean;
	setInviteFriendsModal: (value: boolean) => void;
	league: LeagueWithSportsAndSeries;
}

const InviteFriendsModal: React.FC<InviteFriendsModalProps> = ({
	inviteFriendsModal,
	setInviteFriendsModal,
	league,
}) => {
	const linkRef = useRef<HTMLInputElement>(null);

	const handleCopyLink = () => {
		if (linkRef.current) {
			linkRef.current.select();
			document.execCommand("copy");
		}
	};

	return (
		<Modal
			show={inviteFriendsModal}
			onHide={() => setInviteFriendsModal(false)}
			centered
			className="text-light border-info"
		>
			<Modal.Header closeButton >
				<Modal.Title>
					<FaUsers className="mb-1 me-2" /> Invite Friends
				</Modal.Title>
			</Modal.Header>
			<Modal.Body >
				<p>Send this link to your friends to join league:</p>
				<Form.Group>
					<Form.Control
						type="text"
						readOnly
						ref={linkRef}
						value={`${window.location.origin}/league/${league._id}`}
						
					/>
				</Form.Group>
				<Row className="mt-3">
					<Col>
						<Button
							className="w-100 text-light"
							onClick={handleCopyLink}
							variant="success"
							size="lg"
						>
							Copy Link
						</Button>
					</Col>
				</Row>
			</Modal.Body>
		</Modal>
	);
};

export default InviteFriendsModal;
